<template>
    <div class="float-left mr-1">
        <i
            class="fa fa-edit fa-lg icon-button"
            title="Atualizar"
            @click.stop="abrirModal()"
        ></i>
        <documentos-form
            :idPrestacaoFinal="idPrestacaoFinal"
            :convenio="convenio"
            :dataServicos="dataServicos"
            @atualizarLista="$emit('atualizarLista')"
            operacaoProp="ALTERAR"
            :mostrarModal="mostrarModal"
            :documento="documento"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></documentos-form>
    </div>
</template>

<script>
    
    import DocumentosForm from './DocumentosForm'

export default {
    components: {
        DocumentosForm,
    },

    props: {
        convenio: {
            type: Object,
            default: () => ({})
        },
        idPrestacaoFinal: {
            type: Number,
            default: 0
        },
        dataServicos: {
            type: Object
        },
        documento: {
            type: Object
        }
    },

    data() {
        return {
            mostrarModal: false,
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },
        
        salvar(documentoConvenioDto) {
            this.$store.dispatch('addRequest')
                this.dataServicos.atualizarDocumentoPrestacaoFinal(documentoConvenioDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$emit('atualizarLista')
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },
    }
}
</script>